import * as Yup from 'yup'
import moment from 'moment'
import { formatNumber } from '../utils/formatNumber'
import { IsValidEmail } from '../utils/emailValidation'

export const initialRoleValues = {
  corporateDetails: {
    companyName: '',
    companyWebsite: '',
    companySector: '',
    longDescription: '',
    pocUser: '',
    jobRolePoc: [{ name: '', mobile: '', email: '' }],
  },
  jobDetails: {
    tittle: '',
    jobCategory: '',
    jobTypeLevels: [],
    yearOfExperience: [],
    function: '',
    functionId: '',
    internshipDuration: null,
    description: '',
    employmentType: 'ONROLL',
    jobType: 'FULL_TIME',
    workStyle: '',
    publishTo: '',
    maxVacancies: '',
    isExternalJob: false,
    externalLink: '',
    startDate: null,
    endDate: '',
    endTime: moment('00:00', 'HH:mm'),
    isForAll: false,
    hiringType: 'CAMPUS',
    jobRoleDocs: null,
    gigsDuration: [],
    experienceDuration: {
      startYear: 0,
      endYear: 0,
      startMonth: 0,
      endMonth: 0,
    },
  },
  ctc: {
    stipend: false,
    ppoStipend: 0,
    isInternshipBenefits: false,
    internshipBenefits: '',
    period: 'ANNUALLY',
    minCompensation: 0,
    maxCompensation: 0,
    ctcType: 'FIXED',
    isCtcRange: false,
    variableAmount: '',
    isBond: false,
    bondType: '',
    isAdditionalBenefits: false,
    additionalBenefits: '',
    isAnyWhere: false,
    cities: [],
  },
  elgibilty: {
    qualification: ['UG'],
    eligibilityCriteria: [[]],
    jobRoleSkills: [],
    yearOfPassing: [],
    allSelected: false,
    experienceRequired: '',
    scoreCondition: 'AVERAGE',
    scores: {
      tenthScore: 0,
      twelfthScore: 0,
      UGScore: 0,
      PGScore: 0,
      UGDiplomaScore: 0,
      PGDiplomaScore: 0,
    },
    isArrearsAllowed: false,
    // arrearCount: null,
    arrearCount: 0,
    isHistoryArrears: false,
    historyArrearCount: 0,
    isNoArrearsAllowed: false,
  },
  qualifyQuestions: {
    questionType: 'BINARY', // Set default question type to BINARY instead of empty string
    rawQuestion: '',
    question: '',
    answer: ['', ''], // default two options
    correctAnswer: [],
    mandatory: false,
    mixup: false,
  },
  interviewWorkFlow: {
    rounds: [
      {
        name: '',
        type: '',
        // assessmentType: null,
        // faceToFaceType: null,
        description: '',
        // id: '',
        isEditing: true,
      },
    ],
  },
  applicationForm: {
    templateType: '',
    mandatoryQuestions: [],
    customQuestions: [],
  },
  currentState: '',
  status: 0,
  republishedDate: null,
  publishDisabled: false,
  originalMaxCompensation: 0,
}
export const validationRoleSchema = Yup.object({
  corporateDetails: Yup.object({
    companyName: Yup.string(),
    companyWebsite: Yup.string(),
    companySector: Yup.string()
      .nullable()
      .notRequired()
      .transform((value, originalValue) => {
        // Treat empty strings as null so the field can be optional
        return originalValue === '' ? null : value
      }),
    longDescription: Yup.string()
      .nullable()
      .notRequired()
      .transform((value, originalValue) =>
        originalValue === '' ? null : value
      ),
    pocUser: Yup.string(),
    jobRolePoc: Yup.array().of(
      Yup.object().shape({
        name: Yup.string().when(['mobile', 'email'], {
      is: (mobile, email) => !!mobile || !!email,
      then: schema => schema.required('POC Name is required'),
      otherwise: schema => schema,
    }),
        mobile: Yup.string(),
        email: Yup.string().test(
          'email-validation',
          'Invalid email',
          function (value) {
            if (!value) return true // Allow empty values
            const isValid = IsValidEmail(value)
            return isValid === true || isValid.isValid === true
          }
        ),
      })
    ),
  }),
  jobDetails: Yup.object({
    isForAll: Yup.boolean().required('Please select any one method'),
    tittle: Yup.string().required('Please select any one job title/role'),
    jobCategory: Yup.string().required('Please select any one job type'),
    // gigsDuration: Yup.mixed()
    //   .when('jobCategory', {
    //     is: 'GIGS',
    //     then: schema => schema.required('Please enter project duration'),
    //     otherwise: schema => schema.notRequired(),
    //   })
    //   .test(
    //     'valid-project-duration',
    //     'Please enter valid duration',
    //     function (value) {
    //       const { jobCategory } = this.parent
    //       if (jobCategory !== 'GIGS') return true
    //       const { startYear, endYear, startMonth, endMonth } = value || {}
    //       if (
    //         (startYear === 0 || startYear == null) &&
    //         (endYear === 0 || endYear == null) &&
    //         (startMonth === 0 || startMonth == null) &&
    //         (endMonth === 0 || endMonth == null)
    //       ) {
    //         return this.createError({ message: 'Please enter valid duration' })
    //       }
    //       return true
    //     }
    //   ),
    gigsDuration: Yup.mixed()
      .when('jobCategory', {
        is: 'GIGS',
        then: schema => schema.required('Please enter project duration'),
        otherwise: schema => schema.notRequired(),
      })
      .test(
        'valid-project-duration',
        'Please enter valid duration',
        function (value) {
          const { jobCategory } = this.parent
          if (jobCategory !== 'GIGS') return true

          let startYear = 0,
            startMonth = 0,
            endYear = 0,
            endMonth = 0
          if (Array.isArray(value)) {
            ;[startYear, startMonth, endYear, endMonth] = value
          } else if (value && typeof value === 'object') {
            startYear = Number(value.startYear ?? 0)
            startMonth = Number(value.startMonth ?? 0)
            endYear = Number(value.endYear ?? 0)
            endMonth = Number(value.endMonth ?? 0)
          }
          const startYearFinal = (startYear || 0) + (startMonth || 0) / 10 // 3 + 5/10 = 3.5
          const endYearFinal = (endYear || 0) + (endMonth || 0) / 10 // 6 + 0/10 = 6.0
          const isEmpty =
            (startYearFinal == 0 ||
              startYearFinal == null ||
              Number.isNaN(startYearFinal)) &&
            (endYearFinal == 0 ||
              endYearFinal == null ||
              Number.isNaN(endYearFinal))

          if (isEmpty) {
            return this.createError({ message: 'Please enter valid duration' })
          }
          if (endYearFinal <= startYearFinal) {
            return this.createError({
              message: 'End year cannot be earlier than start year',
            })
          }

          return true
        }
      ),
    internshipDuration: Yup.mixed()
      .when('jobCategory', {
        is: val => val === 'INTERNSHIP' || val === 'INTERNSHIP_PPO',
        then: schema => schema.required('Please enter internship duration'),
        otherwise: schema => schema.notRequired(),
      })
      .test(
        'internship-duration',
        'Please enter internship duration',
        value => {
          const jobCategory = this?.options?.context?.jobDetails?.jobCategory
          if (jobCategory != 'INTERNSHIP' && jobCategory != 'INTERNSHIP_PPO')
            return true // null/empty check

          if (Number(value || 0) == 0) {
            return this.createError({
              message: 'Please enter internship duration',
            })
          }
          return true
        }
      ),

    // yearOfExperience: Yup.array()
    //   .required('Please select any one experience level')
    //   .test(
    //     'yearOfExperience-valid',
    //     'Please enter valid experience duration',
    //     function (value) {
    //       // value is the array
    //       if (!Array.isArray(value)) return false
    //       // FRESHER: [0]
    //       if (value.length === 1) {
    //         return value[0] === 0
    //       }
    //       // EXPERIENCE: [0,0,0,0] (should not be all zero)
    //       if (value.length === 4) {
    //         return value.some(v => v !== 0)
    //       }
    //       // BOTH: [0, x, y] (at least one of x or y must be non-zero)
    //       if (value.length === 3) {
    //         return value[1] !== 0 || value[2] !== 0
    //       }
    //       return false // fallback: invalid
    //     }
    //   ),
    // experienceDuration: Yup.mixed().test(
    //   'experienceDuration-required',
    //   'Please enter valid experience duration',
    //   function (value) {
    //     const { yearOfExperience } = this.parent

    //     // Check if experience mode is selected (4 length means 'EXPERIENCED')
    //     const isExperience =
    //       Array.isArray(yearOfExperience) && yearOfExperience.length === 4

    //     if (!isExperience) return true

    //     // Default fallback values
    //     let startYear = 0,
    //       startMonth = 0,
    //       endYear = 0,
    //       endMonth = 0

    //     if (value && typeof value === 'object') {
    //       startYear = Number(value.startYear ?? 0)
    //       startMonth = Number(value.startMonth ?? 0)
    //       endYear = Number(value.endYear ?? 0)
    //       endMonth = Number(value.endMonth ?? 0)
    //     }

    //     const allEmpty =
    //       startYear === 0 && startMonth === 0 && endYear === 0 && endMonth === 0

    //     if (allEmpty) {
    // return this.createError({
    //   message: 'Please enter experience duration',
    // })
    //     }

    //     const isPartial =
    //       ((startYear || startMonth) && !endYear && !endMonth) ||
    //       (!startYear && !startMonth && (endYear || endMonth))

    //     if (isPartial) {
    //       return this.createError({
    //         message: 'Please enter valid experience duration',
    //       })
    //     }

    //     // Compare year-month ranges
    //     if (
    //       endYear < startYear ||
    //       (endYear === startYear && endMonth < startMonth)
    //     ) {
    //       return this.createError({
    //         message: 'End year cannot be earlier than start year',
    //       })
    //     }

    //     return true
    //   }
    // ),
    jobTypeLevels: Yup.array().min(1, 'Please select Experience Level'),
    experienceDuration: Yup.mixed().test(
      'experienceDuration-required',
      'Please enter valid experience duration',
      function (value) {
        const { yearOfExperience, jobTypeLevels } = this.parent

        // Detect modes
        const isExperienced =
          Array.isArray(jobTypeLevels) &&
          jobTypeLevels[0] === 'EXPERIENCED' &&
          Array.isArray(yearOfExperience) &&
          yearOfExperience.length === 4
        const isBoth =
          Array.isArray(jobTypeLevels) && jobTypeLevels[0] === 'BOTH'

        // Only validate for EXPERIENCED or BOTH
        if (!isExperienced && !isBoth) return true

        // Extract values
        let startYearOnly = 0,
          startMonth = 0,
          endYearOnly = 0,
          endMonth = 0,
          startYear,
          endYear

        if (value && typeof value === 'object') {
          startYearOnly = Number(value.startYear ?? 0)
          startMonth = Number(value.startMonth ?? 0)
          endYearOnly = Number(value.endYear ?? 0)
          endMonth = Number(value.endMonth ?? 0)
          startYear = (startYearOnly || 0) + (startMonth || 0) / 10 // 3 + 5/10 = 3.5
          endYear = (endYearOnly || 0) + (endMonth || 0) / 10 // 6 + 0/10 = 6.0
        }

        if (isExperienced) {
          const allEmpty = startYear == 0 && endYear == 0

          if (allEmpty) {
            return this.createError({
              message: 'Please enter experience duration',
            })
          }

          const isPartial = !startYear || !endYear

          if (isPartial) {
            return this.createError({
              message: 'Please enter valid experience duration',
            })
          }

          // // Convert to decimal format for comparison
          // const startDecimal = startYear + startMonth / 12
          // const endDecimal = endYear + endMonth / 12
          // Compare start pair vs end pair
          if (startYear >= endYear) {
            return this.createError({
              message: 'End year cannot be earlier than start year',
            })
          }

          return true
        }

        // BOTH: Only validate endYear and endMonth
        if (isBoth) {
          if (endYear == 0 && endMonth == 0) {
            return this.createError({
              message: 'Please enter valid experience duration',
            })
          }
          // Optionally, add more checks for endYear/endMonth if needed
          return true
        }

        return true
      }
    ),
    function: Yup.string().required('Please select any one function'),
    otherFunction: Yup.string().when('function', {
      is: 'OTHERS',
      then: schema => schema.required('Please enter other function'),
      otherwise: schema => schema.notRequired(),
    }),
    description: Yup.string().test(
      'no-empty-html',
      'Please enter description',
      value => {
        if (!value) return false // null/empty check
        // remove HTML tags and trim spaces
        const plainText = value?.replace(/<[^>]*>/g, '')?.trim()
        return plainText?.length > 0
      }
    ),
    employmentType: Yup.string().required('Please select On Roll/Off Roll'),

    yearOfExperience: Yup.array(),

    workStyle: Yup.string().required('Please select any one work style'),

    publishTo: Yup.string().required('Please select any one gender'),

    maxVacancies: Yup.number().typeError('Must be a number'),
    isExternalJob: Yup.boolean(),
    externalLink: Yup.string().when('isExternalJob', {
      is: true,
      then: schema => schema.required('External link is required'),
      otherwise: schema => schema.notRequired(),
    }),
    startDate: Yup.date().required('Please enter application start date'),
    endDate: Yup.date().required('Please enter application end date'),
    // endTime: Yup.string().required('Please enter application end time'),
  }),
  ctc: Yup.object({
    stipend: Yup.boolean(),
    ppoStipend: Yup.number()
      .nullable()
      .when('stipend', {
        is: false,
        then: schema => {
          return schema.test(
            'is-required-for-internship',
            'Please enter the stipend amount',
            function (value) {
              const { parent, path, createError } = this

              const jobCategory =
                this?.options?.context?.jobDetails?.jobCategory
              const isInternship = jobCategory === 'INTERNSHIP_PPO'
             
              if (isInternship && parent.stipend === false) {
                return value !== null && value !== undefined && value > 0
              }
              return true
            }
          )
        },
        otherwise: schema => schema.nullable().notRequired(),
      }),

    period: Yup.string().required('Pay Type is required'),

    // Yup schema
    minCompensation: Yup.number()
      .transform(v => (v === '' || v === null ? undefined : Number(v)))
      .test(
        'minCompensation-required',
        'Please enter the Amount',
        function (value) {
          // Get jobCategory from parent form values (this is more reliable than context)
          const { jobDetails } = this.options.context
          const jobCategory = jobDetails?.jobCategory

          // Only require for these categories
          if (
            [
              'PLACEMENT',
              'INTERNSHIP_PPO',
              'INTERNSHIP',
              'APPRENTICESHIP',
              'GIGS',
            ].includes(jobCategory)
          ) {
            const stipend = this.options.context?.ctc?.stipend
            if (
              ((!value || value === 0) &&
                jobCategory != 'INTERNSHIP' &&
                jobCategory != 'APPRENTICESHIP') ||
              (!value && stipend === false &&
                (jobCategory == 'INTERNSHIP' || jobCategory == 'APPRENTICESHIP'))
            ) {
              return false // This will trigger the error
            }

            // // Check if minimum is less than old maximum (for republish)
            // // Use context for these values since they don't change during form interaction
            // const publishDisabled = this.options.context?.publishDisabled
            // const originalMaxCompensation =
            //   this.options.context?.originalMaxCompensation
            // const isCtcRange = this.options.context?.ctc?.isCtcRange  
            // console.log(publishDisabled,originalMaxCompensation,'publishDisabled,originalMaxCompensation',this.options.context?.ctc?.isCtcRange,'this.options.context?.isCtcRange')
            // if (publishDisabled && originalMaxCompensation && !isCtcRange) {
            //   const originalMax = Number(originalMaxCompensation) || 0
            //   const currentMin = Number(value) || 0
            //   if (currentMin < originalMax) {
            //     return this.createError({
            //       message:
            //         'Minimum compensation cannot be less than the old maximum compensation',
            //     })
            //   }
            // }
          }

          return true // Validation passed
        }
      ),
    maxCompensation: Yup.number().when(['isCtcRange', 'minCompensation'], {
      is: (isCtcRange, minCompensation) =>
        isCtcRange &&
        minCompensation !== undefined &&
        minCompensation !== null &&
        minCompensation !== '',
      then: schema =>
        schema
          .required('Please enter the CTC')
          .min(
            Yup.ref('minCompensation'),
            'Maximum cannot be less than minimum'
          )
          .max(
            20000000,
            'Maximum compensation must be less than or equal to 2 crores'
          ),
      otherwise: schema => schema.notRequired(),
    }),
    // Free-text field — optional, no validation.
    variableAmount: Yup.string().notRequired(),
    ctcType: Yup.mixed()
      .required('Please select a CTC type')
      .test(
        'not-null',
        'Please select a CTC type',
        value => value !== null && value !== undefined
      ),
    additionalBenefits: Yup.string().when('isAdditionalBenefits', {
      is: true,
      then: schema =>
        schema.test(
          'no-empty-html',
          'Please enter description',
          value => {
            if (!value) return false // null/empty check
            // remove HTML tags and trim spaces
            const plainText = value?.replace(/<[^>]*>/g, '')?.trim()
            return plainText?.length > 0
          }
        ),
      otherwise: schema => schema.notRequired(),
    }),
    bondType: Yup.string().when('isBond', {
      is: true,
      then: schema => schema.required('Bond type is required'),
      otherwise: schema => schema.notRequired(),
    }),
    isAnyWhere: Yup.boolean(),

    cities: Yup.array().when('isAnyWhere', {
      is: false,
      then: schema =>
        schema
          .min(1, 'Please select job location')
          .required('Please select job location'),
      otherwise: schema => schema.notRequired(),
    }),
  }),
  elgibilty: Yup.object({
    isArrearsAllowed: Yup.boolean(),
    isHistoryArrears: Yup.boolean(),
    isNoArrearsAllowed: Yup.boolean().test(
      'arrears-selection-required',
      'Please select an arrears option',
      function (value) {
        const root = this.from?.[this.from.length - 1]?.value
        if (root?.jobDetails?.isForAll === true) return true
        const { isArrearsAllowed, isHistoryArrears } = this.parent
        return !!(isArrearsAllowed || isHistoryArrears || value)
      }
    ),
    yearOfPassing: Yup.array().test(
      'yearOfPassing-conditional',
      'Please select year',
      function (value) {
        const root = this.from?.[this.from.length - 1]?.value
        if (root?.jobDetails?.isForAll === true) return true
        return Array.isArray(value) && value.length >= 1
      }
    ),

    eligibilityCriteria: Yup.array()
      .default([])
      .nullable()
      .test(
        'eligibilityCriteria-or-allSelected',
        'Please Select Qualification',
        function (value) {
          const root = this.from?.[this.from.length - 1]?.value
          if (root?.jobDetails?.isForAll === true) return true
          const { allSelected } = this.parent
          if (allSelected) return true
          // Check for at least one non-empty array inside
          return (
            Array.isArray(value) &&
            value.length > 0 &&
            value.some(inner =>
              Array.isArray(inner)
                ? inner.length > 0
                : Object.keys(inner || {}).length > 0
            )
          )
        }
      ),
    //   eligibilityCriteria: Yup.array()
    // .of(Yup.array().of(Yup.object().required()))
    // .test(
    //   'not-null-or-empty',
    //   'At least one eligibility criteria is required',
    //   value => Array.isArray(value) && value.some(arr => Array.isArray(arr) && arr.length > 0)
    // ),
    // eligibilityCriteria: Yup.array()
    //   .of(
    //     Yup.array().of(
    //       Yup.object().shape({
    //         degreeId: Yup.string().required(),
    //         degreeType: Yup.string(),
    //         streamId: Yup.string().nullable(),
    //         specialisationId: Yup.array().of(Yup.string()),
    //       })
    //     )
    //   )
    //   .required(),
    // eligibilityCriteria: Yup.array()
    // .of(
    //   is: true,
    //   then: schema =>
    //     schema
    //       .required('Enter current arrears count')
    //       .min(1, 'Enter current arrears count'),
    //   otherwise: schema => schema.notRequired(),
    // }),
    arrearCount: Yup.number().test(
      'arrearCount-main',
      'Enter current arrears count',
      function (value) {
        const root = this.from?.[this.from.length - 1]?.value
        if (root?.jobDetails?.isForAll === true) return true
        if (!this.parent.isArrearsAllowed) return true
        if (
          !value ||
          value === undefined ||
          value === null ||
          Number(value) < 1
        ) {
          return this.createError({
            message: 'Please enter a valid number',
            path: `${this.path}`,
          })
        } else if (Number(value) > 40) {
          return this.createError({
            message: 'Must be less than 40',
            path: `${this.path}`,
          })
        }
        return true
      }
    ),
    historyArrearCount: Yup.number().test(
      'historyArrearCount-main',
      'Enter history of arrears count',
      function (value) {
        const root = this.from?.[this.from.length - 1]?.value
        if (root?.jobDetails?.isForAll === true) return true
        if (!this.parent.isHistoryArrears) return true
        if (
          !value ||
          value === undefined ||
          value === null ||
          Number(value) < 1
        ) {
          return this.createError({
            message: 'Please enter a valid number',
            path: `${this.path}`,
          })
        } else if (Number(value) > 40) {
          return this.createError({
            message: 'Must be less than 40',
            path: `${this.path}`,
          })
        }
        return true
      }
    ),
  }),
  qualifyQuestions: Yup.object({
    // question: Yup.string().required('Question is required'),
    question: Yup.string().test('not-empty', 'Question is required', value => {
      if (!value) return false
      // Remove HTML tags and whitespace
      const text = value
        .replace(/<(.|\n)*?>/g, '')
        .replace(/&nbsp;/g, '')
        .trim()
      return text.length > 0
    }),
    answer: Yup.array()
      .of(Yup.string().required('Option is required'))
      .min(2, 'At least two options are required')
      .max(5, 'No more than five options')
      .test(
        'no-duplicates',
        'Duplicate options are not allowed',
        function (value) {
          if (!value || !Array.isArray(value)) return true

          // Filter out empty values and create a set of non-empty values
          const nonEmptyValues = value.filter(
            option => option && option.trim() !== ''
          )

          // If less than 2 non-empty values, don't check for duplicates yet
          if (nonEmptyValues.length < 2) return true

          const uniqueValues = new Set(
            nonEmptyValues.map(option => option.trim().toLowerCase())
          )

          // If there are duplicates, the set size will be less than the array length
          if (uniqueValues.size !== nonEmptyValues.length) {
            return this.createError({
              message: 'Duplicate options are not allowed',
            })
          }

          return true
        }
      ),
    correctAnswer: Yup.array()
      .min(1, 'Select at least one correct answer')
      .test(
        'correct-answer-count',
        'Number of correct answers must be at least one less than total options',
        function (correctAnswers) {
          const { answer, questionType } = this.parent

          if (questionType !== 'MULTIPLE') return true

          const nonEmptyAnswers = answer.filter(opt => opt && opt.trim() !== '')

          // Allow at least one option to be unchecked
          if (
            correctAnswers.length >= 1 &&
            correctAnswers.length < nonEmptyAnswers.length
          ) {
            return true
          }

          return this.createError({
            message: 'At least one option must remain unchecked',
          })
        }
      ),
    // ...other fields as needed
  }),
  //  interviewWorkFlow: Yup.object().shape({
  //     rounds: Yup.array().of(
  //       Yup.object().shape({
  //         name: Yup.string().required('Round name is required'),
  //         type: Yup.string().required('Evaluation type is required'),
  //         // Add more as needed

  //         assessmentType: Yup.string()
  //         .nullable()
  //         .when('type', (type, schema) => {
  //           if (type === 'ASSESMENT') {
  //             return schema.required('Assessment type is required');
  //           }
  //           return schema;
  //         }),
  //         faceToFaceType: Yup.string()
  //         .nullable()
  //         .when('type', (type, schema) => {
  //           if (type === 'FACE_TO_FACE') {
  //             return schema.required('Face To Face type is required');
  //           }
  //           return schema;
  //   }),
  //         description: Yup.string().test(
  //           'not-empty',
  //           'Round description is required',
  //           value => {
  //             if (!value) return false
  //             // Remove HTML tags and whitespace
  //             const text = value
  //               .replace(/<(.|\n)*?>/g, '')
  //               .replace(/&nbsp;/g, '')
  //               .trim()
  //             return text.length > 0
  //           }
  //         ),
  //       })
  //     ),
  //   }),
  interviewWorkFlow: Yup.object().shape({
    rounds: Yup.array()
      .of(
        Yup.object().shape({
          name: Yup.string()
            .test(
              'is-required-if-filled',
              'Round name is required',
              function (value) {
                // Get the current round object
                const round = this.parent
                // If any field except name has a value, then name is required
                const hasOtherFieldsFilled =
                  round.description?.trim() ||
                  round.assessmentType ||
                  round.faceToFaceType ||
                  (round.type && round.type !== 'ASSESMENT')

                // If no other fields are filled, name is not required
                if (!hasOtherFieldsFilled) return true

                // If other fields are filled, name is required
                return !!value?.trim()
              }
            )
            .test(
              'no-duplicate-name',
              'Round name already exists',
              function (value) {
                if (!value || !value.trim()) return true

                // Get the current form values from the context
                const formValues = this.options?.context?.values
                if (!formValues?.interviewWorkFlow?.rounds) return true

                const rounds = formValues.interviewWorkFlow.rounds
                if (!Array.isArray(rounds)) return true

                // Get current round index from the path
                const pathParts = this.path.split('.')
                const currentIndex = parseInt(pathParts[pathParts.length - 2])

                // Check if this name exists in other rounds
                const duplicateExists = rounds.some(
                  (round, index) =>
                    index !== currentIndex &&
                    round.name &&
                    round.name.trim().toLowerCase() ===
                      value.trim().toLowerCase()
                )

                return !duplicateExists
              }
            ),
          type: Yup.string().test(
            'is-required-if-filled',
            'Please select the Evaluation type',
            function (value) {
              const round = this.parent
              // Only require type if name is provided
              if (round.name?.trim()) {
                return !!value
              }
              return true
            }
          ),
          description: Yup.string().test(
            'is-required-if-filled',
            'Please enter description',
            function (value) {
              const round = this.parent
              // Only require description if name is provided
              if (round.name?.trim()) {
                // Check if description is empty or just contains an empty paragraph tag
                if (!value || value.trim() === '' || value === '<p><br></p>' || value === '<p></p>') {
                  return false
                }
                return true
              }
              return true
            }
          ),
          assessmentType: Yup.string()
            .nullable()
            .when('type', (type, schema) => {
              if (type === 'ASSESMENT') {
                return schema.required('Assessment type is required')
              }
              return schema
            }),
          faceToFaceType: Yup.string()
            .nullable()
            .when(['type', 'name'], {
              is: (type, name) => type === 'FACE_TO_FACE' && name?.trim(),
              then: () =>
                Yup.string().required('Face To Face type is required'),
            }),
        })
      )
      .test(
        'no-duplicate-names',
        'Round names already exists',
        function (value) {
          if (!value || !Array.isArray(value)) return true

          // Filter out rounds with empty names and get non-empty names
          const roundsWithNames = value.filter(
            round => round && round.name && round.name.trim() !== ''
          )

          // Check for duplicate names (case-insensitive)
          const names = roundsWithNames.map(round =>
            round.name.trim().toLowerCase()
          )
          const uniqueNames = new Set(names)

          if (names.length !== uniqueNames.size) {
            return this.createError({ message: 'Round names must be unique' })
          }

          return true
        }
      ),
  }),
})

// Helper to check if a round has any non-empty field
export const isNonEmptyRound = r =>
  !!(r.name || r.type || r.assessmentType || r.faceToFaceType || r.description)
// Helper: Get error value from errors object by dot-path (e.g. 'rounds.0.roundName')
export function getErrorByDotPath(errors, dotPath) {
  return dotPath.split('.').reduce((acc, key) => {
    // Convert array indices to numbers
    if (Array.isArray(acc) && !isNaN(Number(key))) {
      return acc[Number(key)]
    }
    return acc ? acc[key] : undefined
  }, errors)
}

export function makeTouchedFromErrors(errors) {
  if (Array.isArray(errors)) {
    return errors.map(e => makeTouchedFromErrors(e))
  } else if (errors && typeof errors === 'object') {
    const touchedObj = {}
    for (const key in errors) {
      touchedObj[key] = makeTouchedFromErrors(errors[key])
    }
    return touchedObj
  }
  return true
}

export function mapAPIToQualifyQuestions(data) {
  return {
    questionType: data?.questionBank?.questionType,
    question: data?.questionBank?.question || '',
    rawQuestion: data?.questionBank?.rawQuestion || '',
    answer: data?.questionBank?.answer || ['', ''],
    correctAnswer: data?.correctAnswer || [],
    mandatory: data?.mandatory ?? false,
    mixup: data?.mixup ?? false,
  }
}

export function getLabel(data) {
  if (Array.isArray(data)) {
    const typesArray = [...new Set(data.map(item => item.type))]

    const customOrder = [
      'UG',
      'PG',
      'DIPLOMA',
      'P.G.DIPLOMA',
      'P_G_DIPLOMA',
      'PHD',
    ]

    const normalizedTypes = typesArray.map(type =>
      ['P.G.DIPLOMA', 'P_G_DIPLOMA'].includes(type) ? 'DIPLOMA' : type
    )

    const uniqueTypes = [...new Set(normalizedTypes)]

    const sortedQualifications = uniqueTypes
      .filter(type => customOrder.includes(type)) // Keep only valid types
      .sort((a, b) => customOrder.indexOf(a) - customOrder.indexOf(b))
    return sortedQualifications
    // setCriteriaTypes(sortedQualifications)
  }
}

export const getJobScheduleLabel = (jobType, employmentType) => {
  const jobTypeMap = {
    PART_TIME: 'Part Time',
    FULL_TIME: 'Full Time',
  }

  const employmentTypeMap = {
    CONTRACT: 'Off Roll/Contractual',
    ONROLL: 'On Roll',
  }

  const jobLabel = jobTypeMap[jobType] || ''
  const employmentLabel = employmentTypeMap[employmentType] || ''

  return `${jobLabel}${employmentLabel ? ` (${employmentLabel})` : ''}`
}

export const extractExperienceDuration = (experience = []) => {
  const [minExp = '0', maxExp = '0'] = experience.map(String)

  const [minYear = '0', minMonth = '0'] = minExp.split('.')
  const [maxYear = '0', maxMonth = '0'] = maxExp.split('.')

  return {
    minYear,
    minMonth,
    maxYear,
    maxMonth,
  }
}

export const getJobScheduleText = (previewData = {}, date = {}) => {
  const jobType = previewData?.jobTypeLevels?.[0] || 'ENTRY'
  const jobCategory = previewData?.jobCategory
  // 1. Map jobTypeLevels to label
  const typeLabelMap = {
    ENTRY: 'Freshers',
    INTERN: 'Freshers',
    BOTH: 'Both',
    EXPERIENCED: 'Experienced',
  }
  const jobLevelText = typeLabelMap[jobType] || ''

  // 2. Determine if experience duration should be shown
  const showDuration =
    jobCategory && jobType !== 'INTERN' && jobType !== 'ENTRY'

  // 3. Format duration
  const formatDuration = () => {
    const minYear = date?.minYear ?? 0
    const minMonth = date?.minMonth ?? 0
    const maxYear = date?.maxYear ?? 0
    const maxMonth = date?.maxMonth ?? 0
    const hasMax =
      previewData?.status != 1
        ? previewData?.yearOfExperience?.[1]
        : previewData?.yearOfExperience?.[2]

    const format = (y, m) =>
      `${y}${y <= 1 ? 'yr' : ' yrs'} ${m}${m !== 1 ? 'mos' : 'mo'}`

    return showDuration
      ? ` ( ${format(minYear, minMonth)}${
          hasMax ? ` - ${format(maxYear, maxMonth)}` : ''
        } )`
      : ''
  }

  return jobLevelText + formatDuration()
}

export const handleCapitalize = value => {
  if (value) {
    let word = value.split(' ')

    for (let i = 0; i < word.length; i++) {
      word[i] = word[i].charAt(0).toUpperCase() + word[i].slice(1)
    }
    return word.join(' ') + ' - '
  }
}

export const getCompensationDetails = previewData => {
  const formatNumber = val =>
    val?.toLocaleString('en-IN', { maximumFractionDigits: 0 }) || '0'

  if (!previewData) return ''

  const {
    CTCPeriod,
    jobCategory,
    rolePublishedBy,
    minCompensation,
    maxCompensation,
    internshipDuration,
    gigsDuration,
    ctcType,
    isBond,
  } = previewData

  const isMonthly =
    CTCPeriod === 'MONTHLY' ||
    (jobCategory === 'INTERNSHIP' && rolePublishedBy === 'INSTITUTE')

  const periodPrefix = isMonthly
    ? 'Monthly - '
    : CTCPeriod
    ? handleCapitalize(CTCPeriod)
    : ''

  let compRange = ''
  if (minCompensation === maxCompensation) {
    compRange = `₹ ${formatNumber(Number(minCompensation))}`
  } else {
    compRange = minCompensation
      ? `₹ ${formatNumber(Number(minCompensation))} - ₹ ${formatNumber(
          Number(maxCompensation)
        )}`
      : `₹ ${formatNumber(Number(maxCompensation))}`
  }

  // Internship duration formatting
  let durationText = ''
  if (
    jobCategory === 'INTERNSHIP' &&
    Number(internshipDuration) &&
    Number(internshipDuration) !== 0
  ) {
    const days = Number(internshipDuration)
    if (days >= 30) {
      const months = days / 30
      const isWhole = months % 1 === 0
      durationText = `${isWhole ? months : months.toFixed(1)} Month${
        months === 1 || months === 1.0 ? '' : 's'
      }`
    } else {
      durationText = `${days} Day${days === 1 ? '' : 's'}`
    }
  }

  // Gigs duration formatting
  if (jobCategory === 'GIGS' && gigsDuration?.length) {
    const [start, end] = gigsDuration
    durationText = `${start} yrs${end ? ` - ${end} yrs` : ''}`
  }

  const durationStr = durationText ? ` (${durationText})` : ''

  const ctcTypeStr =
    ctcType === 'FIXED'
      ? ' (Fixed)'
      : ctcType === 'FIXED_VARIABLE'
      ? ' (Fixed+Variable)'
      : ''

  const bondStr = isBond ? '  Bond' : ''

  return `${periodPrefix}${compRange}${durationStr}${ctcTypeStr}${bondStr}`
}

export function formatAMPM(date) {
  let hours = date.getUTCHours()
  let minutes = date.getUTCMinutes()
  const ampm = hours >= 12 ? 'PM' : 'AM'
  hours = hours % 12
  hours = hours || 12 // Handle midnight (0 hours)
  minutes = minutes < 10 ? '0' + minutes : minutes
  const strTime = hours + ':' + minutes + ' ' + ampm
  return strTime
}

export const detectDateFormat = dateString => {
  const dateFormatRegex = [
    /\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}/, // ISO 8601 format
    /\d{2}\/\d{2}\/\d{4}/, // DD/MM/YYYY format
    /\d{4}-\d{2}-\d{2}/, // YYYY-MM-DD format
  ]

  for (const regex of dateFormatRegex) {
    if (regex.test(dateString)) {
      return regex.toString().replace(/\//g, '').replace(/\\/g, '')
    }
  }

  return null
}
export const dateConversion = ({ date, convertTo }) => {
  const detectedFormat = detectDateFormat(date)
  if (convertTo === 'Date-Month-Year') {
    const getdate = new Date(date)
    const day = getdate.getUTCDate().toString().padStart(2, '0')
    const month = (getdate.getUTCMonth() + 1).toString().padStart(2, '0')
    const year = getdate.getUTCFullYear().toString()
    return `${day}-${month}-${year}`
  } else if (convertTo === 'Date/Month/Year') {
    const getdate = new Date(date)
    const day = getdate.getUTCDate().toString().padStart(2, '0')
    const month = (getdate.getUTCMonth() + 1).toString().padStart(2, '0')
    const year = getdate.getUTCFullYear().toString()
    return `${day}/${month}\/${year}`
  } else if (
    detectedFormat ===
    /\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}/
      .toString()
      .replace(/\//g, '')
      .replace(/\\/g, '')
  ) {
    if (convertTo === 'YYYY-MM-DD') {
      const formattedDate = new Date(date).toISOString().split('T')[0]
      return formattedDate
    }
  } else if (
    detectedFormat ===
    /\d{2}\/\d{2}\/\d{4}/.toString().replace(/\//g, '').replace(/\\/g, '')
  ) {
    if (convertTo == 'YYYY-MM-DD') {
      return date?.split('/')?.reverse()?.join('-')
    }
  } else if (
    detectedFormat ===
    /\d{4}-\d{2}-\d{2}/.toString().replace(/\//g, '').replace(/\\/g, '')
  ) {
    if (convertTo == 'DD/MM/YYYY') {
      return date?.split('-')?.reverse()?.join('/')
    }
  } else {
    let inputDate = new Date(date)

    let year = inputDate.getFullYear()
    let month = inputDate.getMonth() + 1 // Months are zero-indexed, so add 1
    let day = inputDate.getDate()

    if (month < 10) {
      month = '0' + month
    }
    if (day < 10) {
      day = '0' + day
    }

    let formattedDate = year + '-' + month + '-' + day

    return formattedDate
  }
}

export const splitDate = roleData => {
  let date = {
    minYear: '0',
    maxYear: '0',
    minMonth: '0',
    maxMonth: '0',
  }
  if (roleData?.yearOfExperience?.length > 1) {
    if (roleData?.yearOfExperience?.length == 2) {
      let min = String(roleData?.yearOfExperience?.[0])?.split('.')
      let max = String(roleData?.yearOfExperience?.[1])?.split('.')
      if (min?.length) {
        date.minYear = min?.[0] ?? 0
        date.minMonth = min?.[1] ?? 0
      }
      if (max?.length) {
        date.maxYear = max?.[0] ?? 0
        date.maxMonth = max?.[1] ?? 0
      }
    }
    if (roleData?.yearOfExperience?.length == 4) {
      date.minYear = roleData?.yearOfExperience?.[0] ?? 0
      date.minMonth = roleData?.yearOfExperience?.[1] ?? 0

      date.maxYear = roleData?.yearOfExperience?.[2] ?? 0
      date.maxMonth = roleData?.yearOfExperience?.[3] ?? 0
    }
  }

  return date
}

export const normalizeEligibilityCriteria = data => {
  if (!Array.isArray(data)) return []
  const nested = Array.isArray(data[0]) ? data : data.length ? [data] : []
  return nested.filter(arr => Array.isArray(arr) && arr.length > 0)
}
export const stripHtml = html => {
  return (html || '').replace(/<[^>]*>?/gm, '').trim()
}

// utils/formStepHandler.js

export const handleStepErrors = ({
  values,
  currentStep,
  errors,
  addNewDrawer,
  stepClass,
}) => {
  const stepKeys = Object.keys(values)
  const currentKey = stepKeys[currentStep]
  const errorsForCurrentStep = errors[currentKey] || {}

  if (currentKey === 'qualifyQuestions' && !addNewDrawer) {
    Object.keys(errorsForCurrentStep).forEach(key => {
      delete errorsForCurrentStep[key]
    })
  }
  const fieldsOrder = Object.keys(values[currentKey] || {})
  const firstErrorField =
    fieldsOrder.find(field => errorsForCurrentStep[field]) || null

  // Scroll to the first error field
  if (firstErrorField) {
    const touched = {}
    fieldsOrder.forEach(field => {
      if (errorsForCurrentStep[field]) {
        touched[`${currentKey}.${field}`] = true
      }
    })
    setTouched(touched)
    const stepContainer = document.querySelector(`.${stepClass}`)
    const element =
      stepContainer?.querySelector(
        `[name="${currentKey}.${firstErrorField}"]`
      ) ||
      stepContainer?.querySelector(`[id="${currentKey}.${firstErrorField}"]`)

    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'center' })
      element.focus()
    }
  }

  return {
    currentKey,
    errorsForCurrentStep,
    touched,
    firstErrorField,
  }
}
export function generateFormikMap(obj, prefix = '') {
  let map = {}
  Object.entries(obj).forEach(([key, value]) => {
    const path = prefix ? `${prefix}.${key}` : key
    if (value && typeof value === 'object' && !Array.isArray(value)) {
      Object.assign(map, generateFormikMap(value, path))
    } else {
      map[key] = path
    }
  })
  return map
}
export function validateMaxGreaterThanMin(max, min) {
  if (Number(max) < Number(min)) {
    return 'Maximum cannot be less than minimum'
  }
  return ''
}
export function getTitle(title) {
  title === 'INTERNSHIP' ||
  title === 'INTERNSHIP_PPO' ||
  title === 'APPRENTICESHIP'
    ? (title = 'Stipend & Job Location')
    : (title = 'CTC & Job Location')
  return title
}

export function buildJobRolePayload(values, currentStep, forRepublish) {
  // Filter valid rounds
  const filteredRounds = values?.interviewWorkFlow?.rounds?.filter(round => {
    const name = (round.name || '').trim()
    const type = (round.type || '').trim()
    const description = stripHtml(round.description)
    return name !== '' && type !== '' && description !== ''
  })

  // Normalize eligibility criteria
  const eligibilityCriteria = normalizeEligibilityCriteria(
    values.elgibilty.eligibilityCriteria
  )
  const arr = values?.jobDetails?.yearOfExperience || []

  // Group values in pairs [int, dec] → number int.dec
  const decimalResult = []
  for (let i = 0; i < arr.length; i += 2) {
    if (arr[i] !== undefined && arr[i + 1] !== undefined) {
      decimalResult.push(Number(`${arr[i]}.${arr[i + 1]}`))
    }
  }

  // Optional debug

  // Normalize and prune scores based on normalized eligibilityCriteria
  // Build a set of selected degree types from eligibilityCriteria
  const selectedTypes = new Set()
  if (Array.isArray(eligibilityCriteria)) {
    const flatItems = eligibilityCriteria.flat(2)
    flatItems.forEach(item => {
      const rawType = item?.degreeType || item?.type
      if (!rawType) return
      const t = String(rawType).toUpperCase()
      const normalized = t === 'P.G.DIPLOMA' || t === 'P_G_DIPLOMA' ? 'DIPLOMA' : t
      selectedTypes.add(normalized)
    })
  }

  const allowedScoreKeys = new Set(['tenthScore', 'twelfthScore'])
  if (selectedTypes.has('UG')) allowedScoreKeys.add('UGScore')
  if (selectedTypes.has('PG')) allowedScoreKeys.add('PGScore')
  if (selectedTypes.has('DIPLOMA')) {
    allowedScoreKeys.add('UGDiplomaScore')
    allowedScoreKeys.add('PGDiplomaScore')
  }

  const currentScores = values?.elgibilty?.scores || {}
  const normalizedScores = {}
  allowedScoreKeys.forEach(key => {
    const raw = currentScores[key]
    const num = raw === '' || raw === null || raw === undefined ? 0 : Number(raw)
    normalizedScores[key] = Number.isNaN(num) ? 0 : num
  })
  
  // Sanitize jobRolePoc to include only non-empty objects
  const sanitizedJobRolePoc = Array.isArray(values?.corporateDetails?.jobRolePoc)
    ? values.corporateDetails.jobRolePoc.filter(
        p => p && typeof p === 'object' && !Array.isArray(p) && Object.keys(p).length > 0
      )
    : []
  // Build newValues object
  return {
    ...values,
    corporateDetails: {
      ...values.corporateDetails,
      jobRolePoc: sanitizedJobRolePoc,
    },
    jobDetails: {
      ...values.jobDetails,
      gigsDuration: Array.isArray(values?.jobDetails?.gigsDuration)
        ? {}
        : values?.jobDetails?.gigsDuration,
      maxVacancies: !values?.jobDetails?.maxVacancies
        ? 0
        : values?.jobDetails?.maxVacancies,
      yearOfExperience: decimalResult || [],
    },

    elgibilty: {
      ...values.elgibilty,
      eligibilityCriteria,
      scores: normalizedScores,
      historyArrearCount: {
        count: values?.elgibilty?.historyArrearCount || 0,
        condition: 'LTE',
      },
      arrearCount: {
        count: values?.elgibilty?.arrearCount || 0,
        condition: 'LTE',
      },
    },
    ctc: {
      ...values.ctc,
      minCompensation: Number(values.ctc.minCompensation) || 0,
      maxCompensation:
        values.ctc.maxCompensation === ''
          ? values.ctc.minCompensation || 0
          : Number(values.ctc.maxCompensation) || 0,
      variableAmount: values.ctc.variableAmount ?? '',
      ctcType: values?.ctc?.ctcType == null ? 'FIXED' : values?.ctc?.ctcType,
    },
    interviewWorkFlow: {
      rounds: (filteredRounds || []).map(r => ({
        ...r,
        name: (r?.name || '').trim(),
        type: (r?.type || '').trim(),
      })),
    },
    currentState: currentStep,
    republishedDate: forRepublish
      ? new Date(Date.now() + 5.5 * 60 * 60 * 1000).toISOString()
      : values.jobDetails.republishedDate,
  }
}
export function flatten(arr) {
  return Array.isArray(arr[0]) ? arr[0] : arr
}

export const universalEduArr = (data, i) =>
  i === 0 && data
    ? data.map((item, index) => ({
        id: index + 1,
        label: getLabel(item),
        value: item,
      }))
    : [
        { id: 1, label: 'UG', value: 'UG' },
        { id: 2, label: 'PG', value: 'PG' },
        { id: 3, label: 'Diploma', value: 'DIPLOMA' },
      ]

// export const processNewFormat = (courseData) => {
//     // Initialize chips array
//     const chips = []

//     // Add "Any Degree" chips
//     courseData?.forEach(degreeObj => {
//       if (degreeObj?.isAllDegree && degreeObj?.degreeType) {
//         chips.push({
//           label: `Any ${degreeObj.degreeType} Degree`,
//           isAll: true,
//           degreeObj,
//         })
//       }
//     })

//     // Process course data if it's an array
//     if (Array.isArray(courseData)) {
//       courseData?.forEach(degree => {
//         // Process streams and specializations
//         const hasSelectedStreams = (degree.streams || []).some(stream => {
//           const specs = stream?.specializations || stream?.specialisations || []
//           const hasSelectedSpecs = specs.some(spec => spec?.isSelected)

//           if (stream?.isSelected) {
//             if (hasSelectedSpecs) {
//               // Add chips for selected specializations
//               specs
//                 .filter(spec => spec?.isSelected)
//                 .forEach(spec => {
//                   chips.push({
//                     label: `${degree.degreeShortForm} - ${stream.streamName} - ${spec.specialisationName}`,
//                     degreeId: degree.degreeId,
//                     streamId: stream.streamId,
//                     specId: spec.specialisationId,
//                   })
//                 })
//             } else {
//               // Add chip for stream without selected specializations
//               chips.push({
//                 label: `${degree.degreeShortForm} - ${stream.streamName}`,
//                 degreeId: degree.degreeId,
//                 streamId: stream.streamId,
//               })
//             }
//           }

//           return stream?.isSelected || hasSelectedSpecs
//         })

//         // Add degree chip if selected and no selected streams/specializations
//         if (degree.isSelected && !hasSelectedStreams) {
//           chips.push({
//             label: degree.degreeShortForm,
//             degreeId: degree.degreeId,
//           })
//         }
//       })
//     }

//   return chips
// }
export const processNewFormat = courseData => {
  const chips = []

  // Add "Any Degree" chips
  courseData?.forEach(degreeObj => {
    if (degreeObj?.isAllDegree && degreeObj?.degreeType) {
      chips.push({
        label: `Any ${degreeObj.degreeType} Degree`,
        isAll: true,
        degreeObj,
      })
    }
  })

  // Process course data if it's an array
  if (Array.isArray(courseData)) {
    courseData?.forEach(degree => {
      // Process streams and specializations
      const streams = degree.streams || []
      let hasSelectedStreams = false

      streams.forEach(stream => {
        const specs = stream?.specializations || stream?.specialisations || []
        const selectedSpecs = specs.filter(spec => spec?.isSelected)

        if (stream?.isSelected) {
          hasSelectedStreams = true

          if (selectedSpecs.length > 0) {
            // Add chips for selected specializations
            selectedSpecs.forEach(spec => {
              chips.push({
                label: `${degree.degreeShortForm} - ${stream.streamName} - ${spec.specialisationName}`,
                degreeId: degree.degreeId,
                streamId: stream.streamId,
                specId: spec.specialisationId,
              })
            })
          } else {
            // Add chip for stream without selected specializations
            chips.push({
              label: `${degree.degreeShortForm} - ${stream.streamName}`,
              degreeId: degree.degreeId,
              streamId: stream.streamId,
            })
          }
        }
      })

      // Add degree chip if selected and no selected streams
      if (degree.isSelected && !hasSelectedStreams) {
        chips.push({
          label: degree.degreeShortForm,
          degreeId: degree.degreeId,
        })
      }
    })
  }

  return chips
}

export function buildEligibilityPayload(courseData) {
  if (!Array.isArray(courseData) || courseData.length === 0) {
    return []
  }

  const result = []

  // Handle degrees with isAllDegree
  courseData
    .filter(degree => degree?.isAllDegree)
    .forEach(degree => {
      result.push({
        degreeType: degree.degreeType,
        degreeShortForm: degree.degreeShortForm || degree.shortForm || '',
        isAllDegree: true,
      })
    })

  // Handle degrees with isSelected (existing logic)
  courseData
    .filter(degree => degree?.isSelected)
    .forEach(degree => {
      const selectedStreams = (degree.streams || []).filter(
        stream => stream?.isSelected
      )

      if (selectedStreams.length > 0) {
        selectedStreams.forEach(stream => {
          const selectedSpecs = (
            stream.specializations ||
            stream.specialisations ||
            []
          )
            .filter(spec => spec?.isSelected)
            .map(spec => spec.specialisationId || spec.id)

          result.push({
            degreeId: degree.degreeId,
            degreeType: degree.type ?? degree.degreeType,
            degreeShortForm: degree.degreeShortForm || degree.shortForm || '',
            streamId: stream.streamId,
            specialisationId: selectedSpecs,
          })
        })
      } else if (degree.isSelected) {
        result.push({
          degreeId: degree.degreeId,
          degreeType: degree.type ?? degree.degreeType,
          degreeShortForm: degree.degreeShortForm || degree.shortForm || '',
        })
      }
    })

  return result
}
